<template>
  <div class="container" v-title :data-title="$t('i18n.basicNodeConfig')">
    <div id="outer-title">
      {{ $t("i18n.basicNodeConfig") }}
    </div>
    <p class="fl failTxt" v-if="!view">{{ $t("i18n.dangerTips") }}</p>
    <div v-loading="loading">
      <jl-table
        :tableData="tableData"
        @handleEdit="handleEdit"
        @handleDelete="handleDelete"
        @getEditData="getEditData"
        @init="init"
        :options="options"
        :columns="columns"
        :operates="operates"
        :total="total"
        :height="$defined.HEIGHT - 260 + 'px'"
      >
      </jl-table>
    </div>
  </div>
</template>
<script>
import { reactive, toRefs, getCurrentInstance } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import jlTable from "../../components/table";
export default {
  name: "OpertionNodeConfig",
  components: {
    jlTable,
  },
  setup(props, { emit }) {
    emit("public_header", true);
    const { proxy } = getCurrentInstance();
    const { t } = useI18n();
    const route = useRoute();
    const state = reactive({
      view: route.query.view,
      formInline: {
        pageNumber: 1,
        pageSize: 10,
      },
      // table数据
      tableData: [],
      options: {
        // table 的参数
        isAdd:
          proxy.$defined.btnPermission("新增维保项次") && !route.query.view, // 是否启用新增功能
        isEdit:
          proxy.$defined.btnPermission("编辑维保项次") && !route.query.view, // 是否启用编辑功能
        isDelete:
          proxy.$defined.btnPermission("删除维保项次") && !route.query.view, // 是否启用删除功能
        highlightCurrentRow: false, // 是否支持当前行高亮显示
        multiSelect: false, // 是否支持列表项选中功能
        pageShow: false, // 是否翻页
        index: true, // 序号
      },
      columns: [
        // 需要展示的列
        {
          prop: "sortNumber",
          label: "number",
          align: "center",
          type: "input",
        },
        {
          prop: "itemSimpleName",
          label: "abbreviation",
          align: "center",
          type: "input",
          rules: [{ required: true, message: t("i18n.input") }],
        },
        {
          prop: "itemName",
          label: "nodeContent",
          align: "left",
          width: 200,
          type: "input",
          rules: [{ required: true, message: t("i18n.input") }],
        },
        {
          prop: "recordProcess",
          label: "recordOperational",
          align: "center",
          type: "switch",
          text: { aText: "yes", aVal: true, iText: "no", iVal: false },
          rules: [{ required: true, message: t("i18n.input") }],
          formatter: (row) => {
            let str = row.recordProcess ? "yes" : "no";
            return t("i18n." + str);
          },
        },
        {
          prop: "picture",
          label: "takePictures",
          align: "center",
          type: "switch",
          text: { aText: "yes", aVal: true, iText: "no", iVal: false },
          rules: [{ required: true, message: t("i18n.input") }],
          formatter: (row) => {
            let str = row.picture ? "yes" : "no";
            return t("i18n." + str);
          },
        },
        {
          prop: "pictureNumber",
          label: "numberOfPictures",
          align: "center",
          type: "input",
        },
      ],
      operates: {
        // 列操作按钮
        width: 140,
        fixed: "right",
        list: [],
      },
      loading: true,
      editData: {},
    });

    const init = async () => {
      let id = route.query.depotId;
      state.loading = true;
      const { data } = await proxy.$api.system.installProjectConfig(id);
      state.tableData = data;
      state.loading = false;
    };

    const handleEdit = async (val) => {
      // 新增/编辑数据
      let msg = val.id ? "edit" : "new";
      if (val.id) {
        for (let k in val) {
          if (val[k] !== undefined) {
            state.editData[k] = val[k];
          }
        }
        val = JSON.parse(JSON.stringify(state.editData));
      }
      for (let key in route.query) {
        val[key] = route.query[key];
      }
      val.id
        ? await proxy.$api.system.editInstallProjectConfig(val.id, val)
        : await proxy.$api.system.addInstallProjectConfig(val);
      proxy.$defined.tip(t("i18n." + msg) + t("i18n.success"), "success");
      // 初始化 刷新
      init();
    };

    const handleDelete = (row) => {
      proxy.$api.system.delInstallProjectConfig(row.id).then(() => {
        init();
        proxy.$defined.tip(t("i18n.delete") + t("i18n.success"), "success");
      });
    };

    const getEditData = (row) => {
      state.editData = row;
    };

    const remoteEleMethod = (val) => {
      var index = state.columns.findIndex((item) => {
        return item.prop === "number";
      });
      if (val) {
        state.columns[index].loading = true;
        setTimeout(() => {
          proxy.$api.maintenance
            .getAllEle({ elevatorNumber: val })
            .then((data) => {
              state.columns[index].data = data.data;
              state.columns[index].loading = false;
            });
        }, 1000);
      } else {
        state.columns[index].data = [];
      }
    };

    return {
      ...toRefs(state),
      handleEdit,
      init,
      handleDelete,
      remoteEleMethod,
      getEditData,
    };
  },
};
</script>
